<template>
  <div class="my_right_c_write">
    <el-input :placeholder="placeholdertitle" class="write_input" v-model="json.title"></el-input>
    <el-input :placeholder="placeholdersubtitle" class="write_input" v-model="json.subtitle"></el-input>
    <p class="my_right_c_write_tip tip" v-if="classTyle !=3">封面图（建议上传图片比例3：2并且大小不能超500kb）</p>
    <p class="my_right_c_write_tip tip" v-else>封面图(请上传900*600的封面图并且大小不能超500kb)</p>
    <el-upload class="avatar-uploader" :action="action" :show-file-list="false" :http-request="Eupload" :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload">
      <img v-if="json.picture" :src="json.picture" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <p class="my_right_c_write_tip tip ist" v-if="classTyle!=3">上传每一张内容图片前确认是否需要添加水印：<input type="checkbox" v-model="isc" /></p>
    <p class="my_right_c_write_tip my_right_c_write_mes" v-if="classTyle!=3">如不加水印，请取消选择</p>
    <p class="my_right_c_write_tip my_right_c_write_mes" v-if="classTyle!=3">JPEG格式上传，每张图片不小于4M</p>
    <div id="wangeditor">
      <div ref="editorElem" style="text-align:left;" id="editorElem"></div>
    </div>
    <p class="my_right_c_write_tip tip" style="margin-top:20px;" v-if="DetailList && DetailList.status == 2">审核不通过原因</p>
    <p class="reason" v-if="DetailList && DetailList.status == 2">{{DetailList.reason}}</p>
    <!-- <span class="previewBtn writebtn">预览</span> -->
    <div class="writeBtnDiv"><span class="releaseBtn writebtn" @click="Release()">发布</span></div>
  </div>
</template>
<style>
  .reason {
    margin-top: 0px;
    width: 100%;
    min-height: 100px;
    background: #ccc;
    padding: 5px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }

  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }

  .my_right_c_write_tip {
    margin: 0 0 10px 0;
    font-size: 14px;
  }

  .my_right_c_write_mes {
    font-size: 12px;
    color: #B83113;
  }

  #wangeditor {
    width: 100%;
    min-height: 300px;
    margin-top: 10px;
  }

  .ist {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 15px;
  }
  .w-e-toolbar{flex-wrap: wrap;}
</style>
<script>
  import E from "wangeditor"; //富文本
  import {imgPreview} from "../../assets/static/js/img"
  export default {
    props: ["classTyle", "activityid", 'id'],
    data() {
      return {
        placeholdertitle: '行记标题',
        placeholdersubtitle: '行记副标题',
        editor: null,
        action: this.baseURL + 'api/upload/uploadFile.do',
        token: {
          token: localStorage.getItem("token")
        },
        json: {
          id: '', //记录ID   非必填
          title: '', //文章标题
          subtitle: '', //文章副标题
          picture: '', //封面图
          content: '', //内容
          navigateid: '', //栏目ID   非必填
          creater: '', //创建人ID
          memberid:'',//用户id
          phone:'',
          type: 1 //1行记\2美图\3参赛作品	
        },
        DetailList: {},
        isc: true,
      }
    },
    methods: {
      Eupload(files) {
        let formData = new FormData()
        var timestamp = Date.parse(new Date());
        formData.append('file', files.file, timestamp + files.file.name)
        // if(this.classTyle == 1){
        //   formData.append('waterMark',1) //去掉水印
        // }
        if (this.classTyle == 3) {
          var _this = this
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.src = _URL.createObjectURL(files.file);
          image.onload = function() {
            if (image.width != 900 && image.height != 600) {
              _this.$message.error("请上传900*600的封面图！")
              return
            }
            _this.axios.post('api/upload/uploadFile.do', formData)
              .then(res => {
                if (res.data.resultCode == 0) {
                  _this.json.picture = res.data.data.fileUrl
                }
              })
            console.log(image.width, image.height);
          };
        } else {
          this.axios.post('api/upload/uploadFile.do', formData)
            .then(res => {
              if (res.data.resultCode == 0) {
                this.json.picture = res.data.data.fileUrl
              }
            })
        }
      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 < 500;
        if (!isLt2M) {
          this.$message.error('上传封面图片大小不能超过500kb!');
        }
        return isLt2M;
      },
      //发布
      Release() {
        if (!this.json.title) {
          this.$message.error("请填写行记标题")
          return;
        }
        // if (!this.json.subtitle) {
        //   this.$message.error("请填写行记副标题")
        //   return;
        // }
        if (!this.json.picture) {
          this.$message.error("请选择封面图")
          return;
        }
        if (!this.json.content) {
          this.$message.error("请填写内容")
          return;
        }
        if (localStorage.getItem("userInfoId")) {
          this.json.creater = localStorage.getItem("userInfoId")
          this.json.memberid = localStorage.getItem("userInfoId")
        } else {
          this.json.creater = sessionStorage.getItem("userInfoId")
          this.json.memberid = sessionStorage.getItem("userInfoId")
        }
        if(sessionStorage.getItem("userInfo")){
          this.json.phone = JSON.parse(sessionStorage.getItem("userInfo")).phone
        }        
        this.json.type = this.classTyle
        if (this.classTyle == 3) {
          this.json.targetid = this.activityid
        }
        this.axios.post('api/c_article/addArticle.do', this.qs(this.json))
          .then(res => {
            if (res.data.code == 0) {
              this.$message.success("发布成功，等待审核！")
            } else {
              if (res.data.message) {
                this.$message.error(res.data.message)
              } else {
                this.$message.error("发布失败！")
              }

            }
          })
      },
      upload(param) {
        return new Promise((resolve, reject) => {
          this.axios.post('api/upload/uploadFile.do', param)
            .then(res => {
              if (res.data.resultCode == 0) {
                resolve(res.data.data.fileUrl)
              }
            })
        })
      },
      getDetail() {
        this.axios.post('api/c_article/getDetail.do', this.qs({
            id: this.id
          }))
          .then(res => {
            this.DetailList = res.data.data
            this.json.title = res.data.data.title
            this.json.subtitle = res.data.data.subtitle
            this.json.picture = res.data.data.picture
            this.json.content = res.data.data.content
            this.json.id = res.data.data.id
            this.editor.txt.html(res.data.data.content)
          })
      }
    },
    mounted() {
     
      if (this.classTyle == 1) {
        this.placeholdertitle = '行记标题'
        this.placeholdersubtitle = '行记副标题'
      }
      if (this.classTyle == 2) {
        this.placeholdertitle = '美图标题'
        this.placeholdersubtitle = '美图副标题'
      }
      if (this.classTyle == 3) {
        this.placeholdertitle = '标题'
        this.placeholdersubtitle = '副标题'
      }
      this.editor = new E(this.$refs.editorElem);
      this.editor.customConfig.uploadImgShowBase64 = true
      // 编辑器的事件，每次改变会获取其html内容
      this.editor.customConfig.onchange = html => {
        this.json.content = html;
        // this.catchData(this.editorContent); // 把这个html通过catchData的方法传入父组件
      };
      this.editor.customConfig.uploadImgMaxSize = 100 * 1024 * 1024
      /* 将图片大小限制为 3M 默认为5M / 
           /* 自定义图片上传（支持跨域和非跨域上传，简单操作）*/
      this.editor.customConfig.customUploadImg = async (files, insert) => {
          var loading =  this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(f,f, f, 0.3)'
          });
        /* files 是 input 中选中的文件列表 */
        for (var i = 0; i < files.length; i++) {
          var timestamp = Date.parse(new Date());
          var arr = []
          var aa = await imgPreview(files[i])
          // console.log(aa);
          
          let formData = new FormData()
          var timestamp = Date.parse(new Date());
          formData.append('file', aa, timestamp + files[i].name)
          if (this.isc && this.classTyle != 3) {
            formData.append('waterMark', 1)
          }
          if (this.classTyle == 3) {
            formData.append('waterMark', 1)
          }
          /* upload方法是后台提供的上传图片的接口 */
          /* insert 是编辑器自带的 获取图片 url 后，插入到编辑器的方法 上传代码返回结果之后，将图片插入到编辑器中*/
          let imgUrl = await this.upload(formData)
          insert(imgUrl)
          loading.close();
        }
      }
      this.editor.customConfig.menus = [
        // 菜单配置
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'foreColor', // 文字颜色
        'justify', // 对齐方式
        'image', // 插入图片
        'fullScreen'
      ];
      this.editor.create(); // 创建富文本实例
      // E.fullscreen.init('#editorElem');
      if (this.id) {
        this.getDetail()
      }
    }

  }
</script>

<style>

</style>
